
import { useContext } from "react";
import { Link } from "react-router-dom";
import UserContext from "../../contexts/UserContext";
import { textes } from "../../constants/textes";


export default function Vpn({vpn, position}) {
    // states
    const {user} = useContext(UserContext);


    // comportements


    // Affichage
    return (
        <tr style={{borderStyle: "none"}}>
            <td className="text-center">{position + 1}</td>
            <td>{vpn?.username}</td>
            {/* <td>{vpn?.mdp}</td> */}
            <td>{vpn.duree !== null ? vpn?.duree : ""}</td>
            <td>{vpn?.datedeb !== null ? vpn?.datedeb.slice(0, 16).replace("T", " à ") : ""}</td>
            <td>{vpn?.datefin !== null ? vpn?.datefin.slice(0, 16).replace("T", " à ") : ""}</td>
            <td>
                <span 
                    className={`badge ${
                        vpn.etat === 1 ? "badge-warning" : 
                        vpn.etat === 2 ? "badge-success" : 
                        vpn.etat === 3 ? "badge-danger" : 
                        ""
                        } mt-2`
                    } 
                    style={{fontSize: 14}}>
                        {
                            vpn.etatdef !== null ? vpn?.etatdef : 
                            "Etat"
                        }
                </span>
            </td>
            <td>{vpn?.datecrea.slice(0, 16).replace("T", " à ")}</td>
            <td className="text-center">
                {(user?.isFullAction || user?.isAdminAction || user?.isConsulterCompteVPN) && 
                    <Link to={`/vpn/${vpn?.code}`} data-toggle="tooltip" title={textes.fr.viewcomptevpnlabel} data-placement="left" className="btn-shadow-primary mr-2 ml-2 btn btn-sm btn-primary">
                        <i className="fa fa-eye"></i>
                    </Link>
                }
            </td>
        </tr>
    )
}